import controller from '../../controller/controller.js';
export default {
	namespaced: true,

	state: {
		bxajaxid: null,
		remote: null,
		link: null,
		title: null,
		items: [],
		loading: false
	},

	getters: {
		items(state) {
			return state.items;
		},

		favoriteEmpty(state) {
			return !state.items || !state.items.length;
		},

		favoriteCount(state) {
			return state.items ? state.items.length : 0;
		},

		favoriteCountByItem(state) {
			return (id) => {
				let result = state.items.find(item => item.id == id);
				return result ? result.id : 0;
			};
		}
	},

	mutations: {
		set(state, data) {
			state.bxajaxid = data.bxajaxid;
			state.remote = data.remote;
			state.link = data.link;
			state.title = data.title;
			state.button = data.button;
			state.showBtn = data.showBtn;
			state.pageLink = data.pageLink;
			state.notificationText = data.notificationText;
			state.items = data.items;
		},

		setLoading(state, value) {
			state.loading = value;
		}
	},

	actions: {
		async request(context, options) {
			context.commit('setLoading', true);
			const response = await fetch(context.state.remote, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					...options,
					bxajaxid: context.state.bxajaxid
				})
			});
			if (!response.ok) {
				console.warn('[vuex] favorite: AJAX request failed', response);
			} else {
				const data = await response.json();
				// console.log('[vuex] favorite: loaded', data);
				context.commit('set', data);
			}
			context.commit('setLoading', false);
		},

		async add(context, options) {
			options.button = context.state.button;
			options.showBtn = context.state.showBtn;
			options.pageLink = context.state.pageLink;
			options.notificationText = context.state.notificationText;
			context.dispatch('request', {
				action: 'add',
				id: options.id
			})
			// .then(() => {
			// 	controller.addNotification(options);
			// });
		},

		async remove(context, options) {
			context.dispatch('request', {
				action: 'remove',
				id: options.id
			});
		},

		async removeAll(context, options) {
			context.dispatch('request', {
				action: 'removeAll',
			});
		}
	}
};